import { render, staticRenderFns } from "./routerList.vue?vue&type=template&id=79bb594c&scoped=true&"
import script from "./routerList.vue?vue&type=script&lang=js&"
export * from "./routerList.vue?vue&type=script&lang=js&"
import style0 from "./routerList.vue?vue&type=style&index=0&id=79bb594c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb594c",
  null
  
)

component.options.__file = "routerList.vue"
export default component.exports